import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ce66aa2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ion-text-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Antal pooler", -1))

import { GroupEnum, GroupType } from '@/assets/interfaces'
import ButtonsRow from '@/components/ButtonsRow.vue'
import { IonContent, IonFooter, IonItem, IonLabel, IonSegment, IonSegmentButton } from '@ionic/vue'
import { reactive } from 'vue'
import Round from '../components/Round.vue'

const MAX_VALUE = 192
const MIN_VALUE = 3


export default /*#__PURE__*/_defineComponent({
  __name: 'Groups',
  props: {
    amount: {},
    participants: {},
    segment: {}
  },
  emits: ['set-participants', 'set-segment', 'set-qualifier', 'set-amount'],
  setup(__props: any, { emit: __emit }) {

const { participants, segment, amount } = __props
const emit = __emit

const state = reactive({
	participants,
	segment,
	amount,
	min: MIN_VALUE,
	max: MAX_VALUE,

	three: 0,
	four: 0,
	five: 0,
	six: 0,
	seven: 0,
	sum: 0
})

const decrease = (value: number = 1) => {
	setParticipants(Math.max(state.participants - value, MIN_VALUE))
}

const increase = (value: number = 1) => {
	setParticipants(Math.min(state.participants + value, MAX_VALUE))
}

const setSegment = (segment: GroupType) => {
	state.segment = segment
	calc()
	emit('set-segment', segment)
}

const setAmount = (amount: number) => {
	state.amount = amount
	calc()
	emit('set-amount', amount)
}

const setParticipants = (participants: number) => {
	state.participants = participants
	calc()
	emit('set-participants', participants)
}

const calc = () => {
	state.three = 0
	state.four = 0
	state.five = 0
	state.six = 0
	state.seven = 0
	const n = state.participants
	if (state.segment === GroupEnum.fourThree || state.segment === GroupEnum.threeFour) {
		if (n === 5) {
			state.five = 1
		} else {
			if (state.segment === GroupEnum.threeFour) {
				// 3 or 4
				const rest = n % 3
				state.four = rest
				state.three = ((n / 3) >> 0) - rest
			} else {
				// 4 or 3
				const tmp = (4 - (n % 4)) % 4
				state.three = tmp
				state.four = (n - tmp * 3) / 4
			}
		}
	} else if (state.segment === GroupEnum.fourFive) {
		// 4 or 5
		if (n < 3) {
			// do nothing
		} else if (n === 3) {
			state.three = 1
		} else if (n === 6) {
			state.six = 1
		} else if (n === 7) {
			state.seven = 1
		} else if (n === 11) {
			state.five = 1
			state.six = 1
		} else {
			state.five = n % 4
			state.four = (n - (n % 4) * 5) / 4
		}
	} else {
		// 5 or 4
		if (n < 3) {
			// do nothing
		} else if (n === 3) {
			state.three = 1
		} else if (n === 6) {
			state.six = 1
		} else if (n === 7) {
			state.seven = 1
		} else if (n === 11) {
			state.five = 1
			state.six = 1
		} else {
			const tmp = (5 - (n % 5)) % 5
			state.four = tmp
			state.five = (n - tmp * 4) / 5
		}
	}

	state.sum = state.three + state.four + state.five + state.six + state.seven
	emit('set-qualifier', state.amount * state.sum)
}
calc()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("h3", null, [
            _createElementVNode("strong", null, _toDisplayString(state.sum) + " st", 1)
          ])
        ]),
        _createVNode(Round, {
          value: state.three,
          color: 'secondary',
          title: '3-pooler',
          highlight: false
        }, null, 8, ["value"]),
        _createVNode(Round, {
          value: state.four,
          color: 'success',
          title: '4-pooler',
          highlight: false
        }, null, 8, ["value"]),
        _createVNode(Round, {
          value: state.five,
          color: 'primary',
          title: '5-pooler',
          highlight: true
        }, null, 8, ["value"]),
        _createVNode(Round, {
          value: state.six,
          color: 'warning',
          title: '6-pooler',
          highlight: false
        }, null, 8, ["value"]),
        _createVNode(Round, {
          value: state.seven,
          color: 'danger',
          title: '7-pooler',
          highlight: true
        }, null, 8, ["value"])
      ]),
      _: 1
    }),
    _createVNode(_unref(IonFooter), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonItem), { lines: "none" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonLabel), null, {
              default: _withCtx(() => [
                _createTextVNode(" Pool storlek (primär & sekondär) ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(IonSegment), {
          color: "tertiary",
          value: state.segment,
          onIonChange: _cache[0] || (_cache[0] = ($event: any) => (setSegment($event.target.value)))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonSegmentButton), { value: "43" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonLabel), null, {
                  default: _withCtx(() => [
                    _createTextVNode("4 & 3")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonSegmentButton), { value: "34" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonLabel), null, {
                  default: _withCtx(() => [
                    _createTextVNode("3 & 4")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonSegmentButton), { value: "45" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonLabel), null, {
                  default: _withCtx(() => [
                    _createTextVNode("4 & 5")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonSegmentButton), { value: "54" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonLabel), null, {
                  default: _withCtx(() => [
                    _createTextVNode("5 & 4")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"]),
        _createVNode(_unref(IonItem), { lines: "none" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonLabel), null, {
              default: _withCtx(() => [
                _createTextVNode(" Antal vidare ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(IonSegment), {
          color: "tertiary",
          value: state.amount,
          onIonChange: _cache[1] || (_cache[1] = ($event: any) => (setAmount(+$event.target.value))),
          class: "mb"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonSegmentButton), { value: 2 }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonLabel), null, {
                  default: _withCtx(() => [
                    _createTextVNode("2")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonSegmentButton), { value: 1 }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonLabel), null, {
                  default: _withCtx(() => [
                    _createTextVNode("1")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"]),
        _createVNode(_unref(IonItem), { lines: "none" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonLabel), null, {
              default: _withCtx(() => [
                _createTextVNode("Antal spelare")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(ButtonsRow, {
          value: state.participants,
          min: state.min,
          max: state.max,
          onValChange: setParticipants,
          onIncrease: increase,
          onDecrease: decrease
        }, null, 8, ["value", "min", "max"])
      ]),
      _: 1
    })
  ], 64))
}
}

})